module.exports = __webpack_public_path__ + "img/7.50a5912e.png";